import React, { useState, useEffect, useMemo } from "react";
import "../taskMainpage/styles/index.less";
import {
  Col,
  Row,
  Tag,
  Layout,
  Select,
  Input,
  Button,
  Card,
  Empty,
  Form,
  Tooltip,
  Table,
  Modal,
  Typography,
  message,
  Divider,
  Spin,
  Switch,
  Popconfirm,
  Breadcrumb,
  Pagination,
} from "antd";
import type { TableProps } from "antd";
import {
  AppstoreOutlined,
  BarsOutlined,
  CopyOutlined,
  DeleteOutlined,
  DoubleRightOutlined,
  EditOutlined,
  EyeOutlined,
  ExceptionOutlined,
  ExclamationCircleFilled,
  PlusOutlined,
  TeamOutlined,
  TrophyOutlined,
  UserOutlined,
  LoginOutlined,
  LogoutOutlined,
  CloudUploadOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import {
  get_all_task,
  task_delete,
  task_update,
  get_task_active,
  get_admin_task,
  toggleSubmissionStatus,
} from "../../services/task";
import { get_all_category } from "../../services/category";
import {
  delete_task_member,
  get_options_member,
  get_task_member,
  update_task_member,
} from "../../services/task_member";
import { get_profile } from "../../services/user";
import { get_task_tutorial } from "../../services/submission";
import { api_optionsUser } from "../../services/user";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import advancedFormat from "dayjs/plugin/advancedFormat";
import utc from "dayjs/plugin/utc";

dayjs.extend(buddhistEra);
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.locale("th");

interface DataType {
  tags: any;
  key: string;
  id: string;
  task_id: string;
  type: string;
  name: string;
  description: string;
  created_date: string;
  img: string;
  start_date: string;
  end_date: string;
  created_by: string;
  details: string;
}

const { Content } = Layout;
const { Option } = Select;
const { Search } = Input;
const { Title } = Typography;
const { confirm } = Modal;

type Props = {};

const Taskmainpage = (props: Props) => {
  const auth = useAuth();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get("search") || "");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [view, setView] = useState<"table" | "card">("table");
  const [sortbyTag, setSortbyTag] = useState<string[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedId, setSelectedId] = useState(null);
  const [currentSearchType, setCurrentSearchType] = useState<
    "text" | "select" | null
  >(null);
  const [tagSelect, setTagSelect] = useState<string | null>(null);
  const [memberDetail, setMemberDetail] = useState<any[]>([]);
  const [expandedTags, setExpandedTags] = useState<{ [key: string]: boolean }>(
    {},
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tutorial, setTutorial] = useState({
    login: "",
    logout: "",
    image_pull: "",
    image_push: "",
    image_tag: "",
  });
  const [editableTutorial, setEditableTutorial] = useState({
    image_tag: "",
    image_push: "",
  });
  const [editingField, setEditingField] = useState<{
    image_tag: boolean;
    image_push: boolean;
  }>({ image_tag: false, image_push: false });

  const [userData, setUser] = useState({
    user_name: "",
    user_code: "",
    org_name: "",
    user_email: "",
    profile_img: "",
    role_name: "",
  });

  const [taskData, setTaskData] = useState<
    {
      key: string;
      id: string;
      task_id: string;
      type: string;
      name: string;
      description: string;
      created_date: string;
      img: string;
      start_date: string;
      end_date: string;
      created_by: string;
      details: string;
      tags: string | string[];
    }[]
  >([]);
  const [taskcard, setTaskCard] = useState<
    {
      key: string;
      id: string;
      task_id: string;
      type: string;
      name: string;
      description: string;
      created_date: string;
      submission_type: string;
      img: string;
      start_date: string;
      end_date: string;
      created_by: string;
      details: string;
      tags: string | string[];
    }[]
  >([]);
  const [viewMode, setViewMode] = useState("admin");
  // Pagination states for table (admin)
  const [page, setPage] = useState<any>(1);
  const [total, setTotal] = useState<any>(0);
  // Pagination states for card (user)
  const [cardPage, setCardPage] = useState<any>(1);
  const [cardTotal, setCardTotal] = useState<any>(0);

  const [optionsCategory, setOptionsCategory] = useState<any>([
    { label: "ทั้งหมด", value: "null" },
  ]);

  const [valueCategory, setValueCategory] = useState<any>("null");
  const [optionsRole, setOptionsRole] = useState<any>([
    {
      label: "Admin",
      value: 2,
    },
    { label: "Member", value: 1 },
  ]);

  // table
  const columns: TableProps<DataType>["columns"] = [
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Task Name")}
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 500,
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Task Type")} and {t("Mode")}
        </div>
      ),
      dataIndex: "submission_type",
      key: "submission_type",
      align: "center",
      render: (_: any, record: any) => {
        const typeMapping: { [key: string]: { color: string; text: string } } =
          {
            "2": { color: "#FF6969", text: "General" },
            "1": { color: "#864AF9", text: "Event" },
          };

        const { color, text } = typeMapping[record.type] || {
          color: "#FF6969",
          text: "Unknown",
        };

        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            {/* <div>
          <Badge color={color} text={text} />
        </div> */}
            <div>{text}</div>
            <div>
              {record.submission_type === 1
                ? "Model"
                : record.submission_type === 2
                  ? "File"
                  : "-"}
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>{t("Tag")}</div>
      ),
      key: "tags",
      dataIndex: "tags",
      width: 150,
      render: (colortag: string, record: any) => {
        try {
          let value_tags =
            typeof record.tags === "string"
              ? JSON.parse(record.tags)
              : record.tags;

          // Check if value_tags is an array
          if (!Array.isArray(value_tags)) {
            return <div>-</div>;
          }

          const result = value_tags
            .map((v: any, index: number) => {
              // Try to find by value (category_id) first, then by label (category name)
              const category = optionsCategory.find(
                (d: any) => d.value === v || d.label === v,
              );
              return category ? { id: v, label: category.label, index } : null;
            })
            .filter(Boolean);

          if (result.length === 0) {
            return <div>-</div>;
          }

          return (
            <div>
              {result.map((item: any) => (
                <Tag key={`${record.task_id}-${item.index}-${item.label}`}>
                  {item.label}
                </Tag>
              ))}
            </div>
          );
        } catch (error) {
          console.error("Error parsing tags:", error, record.tags);
          return <div>-</div>;
        }
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Activity Duration")}
        </div>
      ),
      dataIndex: "event_date",
      key: "event_date",
      render: (_: any, record: any) => {
        try {
          let startDate = null;
          let endDate = null;

          // ดึงข้อมูลจาก event_date
          if (record.event_date) {
            let eventData = record.event_date;

            // Parse JSON ซ้อนกัน (อาจต้อง parse หลายครั้ง)
            while (typeof eventData === "string") {
              try {
                eventData = JSON.parse(eventData);
              } catch (e) {
                break;
              }
            }

            // ถ้าเป็น array ให้เอา element แรก
            if (Array.isArray(eventData) && eventData.length > 0) {
              eventData = eventData[0];
            }

            // ดึงค่า start_date และ end_date จาก object ที่ parse แล้ว
            if (eventData && typeof eventData === "object") {
              startDate = eventData.start_date;
              endDate = eventData.end_date;
            }
          }

          // ถ้าไม่มีข้อมูลใน event_date ให้ใช้ฟิลด์ start_date และ end_date แบบเดิม
          if (!startDate && record.start_date) {
            startDate = record.start_date;
          }
          if (!endDate && record.end_date) {
            endDate = record.end_date;
          }

          // ถ้าไม่มีทั้ง start_date และ end_date แสดง "-"
          if (!startDate || !endDate) {
            return <div style={{ textAlign: "center" }}>-</div>;
          }

          return (
            <div style={{ textAlign: "center" }}>
              <div key={`start-${record.task_id}`}>
                {dayjs(startDate).utc().format("DD MMM ")}
                {dayjs(startDate).utc().add(543, "year").format("YYYY")}
              </div>
              {/* <div
                key={`divider-${record.task_id}`}
                style={{ margin: "4px 0" }}
              >
                ถึง
              </div> */}
              <div key={`end-${record.task_id}`}>
                {dayjs(endDate).utc().format("DD MMM ")}
                {dayjs(endDate).utc().add(543, "year").format("YYYY")}
              </div>
            </div>
          );
        } catch (error) {
          console.error("Error parsing event_date:", error, record.event_date);
          return <div style={{ textAlign: "center" }}>-</div>;
        }
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>
          {t("Active")}
        </div>
      ),
      sorter: false,
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "center",
      render: (_: any, record: any) => {
        let checked = record.status == 1 ? true : false;
        return (
          <Switch
            // checked={record.status}
            checkedChildren="เปิด"
            unCheckedChildren="ปิด"
            checked={checked}
            onChange={async (value, e) => {
              e.stopPropagation();
              const data = {
                status: value ? 1 : 0,
                task_id: record.task_id,
              };
              await task_update({ data });
              getDataTask();
              getTaskActive();
            }}
          />
        );
      },
    },
    {
      title: (
        <div style={{ fontSize: "18px", textAlign: "center" }}>Submit</div>
      ),
      sorter: false,
      dataIndex: "Submit",
      key: "Submit",
      align: "center",
      render: (_: any, record: any) => {
        let checked = record.submission_status == 0 ? true : false;
        return (
          <Switch
            checked={checked}
            checkedChildren="เปิด"
            unCheckedChildren="ปิด"
            onChange={async (value, e) => {
              e.stopPropagation();
              const data = {
                task_id: record.task_id,
              };
              await toggleSubmissionStatus(data);
              getDataTask();
              getTaskActive();
            }}
          />
        );
      },
    },
    {
      title: "",
      key: "action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
          {/* Row 1: Detail, LeaderBoard, Add Member */}
          <Row justify="center" align="middle" style={{ gap: "6px" }}>
            <Tooltip placement="bottom" title="Detail">
              <Col>
                <Button
                  style={{ backgroundColor: "#e6f4ff" }}
                  icon={<EyeOutlined style={{ color: "#0958d9" }} />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/task/detail/${record.task_id}`, {
                      state: { name: record.name },
                    });
                  }}
                />
              </Col>
            </Tooltip>

            <Tooltip placement="bottom" title="LeaderBoard">
              <Col>
                <Button
                  icon={<TrophyOutlined />}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/score/leaderboard/${record.task_id}`);
                  }}
                />
              </Col>
            </Tooltip>

            {/* detail */}
            <Tooltip placement="bottom" title="Add Member">
              <Col
                style={{ color: "#3f8dc4", cursor: "pointer" }}
                onClick={() => navigate(`/team/${record.task_id}`)}
              >
                <Button
                  style={{ backgroundColor: "#daf1e3" }}
                  icon={<UserOutlined style={{ color: "#41B06E" }} />}
                />
              </Col>
            </Tooltip>
          </Row>

          {/* Row 2: Guideline, Edit, Delete (admin only) */}
          {auth.user.role == "Super Admin" || auth.user.role == "Administrator" ? (
            <Row justify="center" align="middle" style={{ gap: "6px" }}>
              <Tooltip placement="bottom" title="Guideline">
                <Col
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleTaskAdmin(record.task_id);
                  }}
                >
                  <Button
                    style={{ backgroundColor: "#d1d7fa" }}
                    icon={
                      <ExceptionOutlined
                        style={{ color: "#615EFC" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTaskAdmin(record.task_id);
                        }}
                      />
                    }
                  />
                </Col>
              </Tooltip>
              <Tooltip placement="bottom" title="Edit">
                <Col
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/task/edit/" + record.task_id);
                  }}
                >
                  <Button
                    style={{ backgroundColor: "#fff4cc" }}
                    icon={<EditOutlined style={{ color: "#FFB84C" }} />}
                  />
                </Col>
              </Tooltip>

              {/* delete */}
              {auth.user.role == "Super Admin" ? (
                <Tooltip placement="bottom" title="Delete">
                  <Col
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (record.role_id == "99999999-0000-0000-0000-999999999999") {
                        Modal.error({
                          title: "Permission Denined!",
                          content: `Not allow to edit Super Admin's data.`,
                        });
                      } else {
                        showDeleteConfirm(record.task_id, record.name);
                      }
                    }}
                  >
                    <Button
                      style={{ backgroundColor: "#FFDFDF" }}
                      icon={<DeleteOutlined style={{ color: "#B31312" }} />}
                    />
                  </Col>
                </Tooltip>
              ) : null}
            </Row>
          ) : null}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getProfile();
  }, []);

  const getTutorial = async (taskId: any) => {
    try {
      const res = await get_task_tutorial({ task_id: taskId });
      setTutorial(res);
      setEditableTutorial({
        image_tag: res.image_tag,
        image_push: res.image_push,
      });
      setEditingField({ image_tag: false, image_push: false });
    } catch (error) {
      console.error(error);
    }
  };

  const getProfile = async () => {
    try {
      const res = await get_profile();
      const user = res.result;
      setUser(user[0]);
    } catch (error) {
      console.error(error);
    }
  };

  // ฟังก์ชันรวมสำหรับดึงข้อมูล task ทั้ง admin และ user mode
  const fetchTasks = async (
    mode: "admin" | "user",
    options?: {
      pageNumber?: number;
      searchText?: string;
      category?: string;
    },
  ) => {
    try {
      const currentPage = mode === "admin" ? page : cardPage;
      const filterData = {
        search:
          options?.searchText !== undefined ? options.searchText : searchText,
        size: mode === "admin" ? 10 : 8,
        page: options?.pageNumber ?? currentPage,
        category:
          options?.category !== undefined ? options.category : valueCategory,
        ...(mode === "user" && { status: 1 }), // user mode ดึงเฉพาะ active
        mode: mode === "admin" ? true : false,
      };

      let res;
      if (mode === "admin") {
        if (auth.user.role === "Super Admin") {
          const data = {
            fields: ["*"],
            filter: filterData,
          };
          res = await get_all_task(data);
        } else if (auth.user.role === "Administrator") {
          const data = {
            user_id: auth.user.user_id,
            fields: ["*,t.status as status,m.status as member_status"],
            filter: filterData,
          };
          res = await get_admin_task(data);
        }

        if (res) {
          setTotal(res.meta.total);
          setPage(res.meta.page);
          setTaskData(res.result);
        }
      } else {
        // user mode
        const data = {
          fields: ["*"],
          filter: filterData,
        };
        res = await get_all_task(data);

        if (res) {
          setCardTotal(res.meta.total);
          setCardPage(res.meta.page);
          setTaskCard(res.result);
        }
      }
    } catch (e) {
      console.error(e);
      if (mode === "user") {
        message.warning("Unable to display Task data");
      }
    }
  };

  // Wrapper functions for backward compatibility
  const getDataTask = (number?: any, searchParams?: any, category?: any) => {
    fetchTasks("admin", {
      pageNumber: number,
      searchText: searchParams,
      category: category,
    });
  };

  const getTaskActive = (number?: any, searchParams?: any, category?: any) => {
    fetchTasks("user", {
      pageNumber: number,
      searchText: searchParams,
      category: category,
    });
  };

  // ข้อมูลของคนทั้งหมด
  const getPersonData = async () => {
    try {
      // setAllPerson(res.result);
    } catch (e) {
      console.error(e);
      message.warning("Unable to display Task data");
    }
  };

  // ข้อมูล category
  const getCategory = async () => {
    try {
      const res = await get_all_category();
      const categoryNames = res.result.map(
        (category: { name: string }) => category.name,
      );

      const options = res.result.map((item: any) => {
        return {
          label: item.name,
          // value: item.name,
          value: item.category_id,
        };
      });
      setSortbyTag(categoryNames);
      setOptionsCategory((prev: any) => [...prev, ...options]);
    } catch (e) {
      console.error(e);
      message.warning("Unable to display Task data");
    }
  };

  // get member
  const getMember = async (id: any) => {
    try {
      const data = { task_id: id };
      const res = await get_options_member(data);

      const filterRole = res.data.map((item: any, ind: number) => {
        return {
          key: ind,
          value: item.user_id,
          role: item.role,
          label: item.name,
          current: true,
        };
      });

      setFields(filterRole);
      form.setFieldsValue({
        member: filterRole,
      });
      const dataOption = await api_optionsUser({ user_id: auth.user.user_id });
      //
      if (Array.isArray(dataOption.data)) {
        setMemberDetail(
          dataOption.data.map((item: any) => {
            return {
              ...item,
              label: item.name,
              value: item.user_id,
            };
          }),
        );
      } else {
        console.warn("Unexpected data format:", res.data);
        setMemberDetail([]);
      }
    } catch (e) {
      console.error("Error fetching member details:", e);
      setMemberDetail([]);
    }
  };

  // delete
  const showDeleteConfirm = (task_id: string, name: string) => {
    confirm({
      title: t("delete title"),
      icon: <ExclamationCircleFilled style={{ color: "#FF3B30" }} />,
      content: (
        <div
          className="custom-modal-content-news"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center", // จัดข้อความให้อยู่ตรงกลาง
          }}
        >
          <p>{t("You want to delete the tasks")} :</p>
          <p>
            <strong>{name}</strong>
          </p>
          <p>{t("yes or no")}</p>
        </div>
      ),
      okText: t("confirm"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk: async () => {
        try {
          const res = await task_delete({ task_id: task_id });
          message.success("Delete Success!");
          getDataTask();
        } catch (e) {
          console.error(e);
        }
      },
      onCancel() {},
    });
  };

  const showModal = async (id: any) => {
    setSelectedId(id);
    await getTutorial(id);
    setIsModalOpen(true);
  };

  const handleTaskAdmin = async (task_id: any) => {
    try {
      getMember(task_id);
      await showModal(task_id);
    } catch (e) {
      console.error(e);
    }
  };

  // mode card or table
  const handleChangeViewMode = (value: "table" | "card") => {
    setView(value);
  };

  const onSearch = (value: string) => {
    setSearchText(value);
    setTagSelect(null);
    setCurrentSearchType("text");
  };

  const data = useMemo(() => {
    if (viewMode == "admin") {
      return taskData;
    } else {
      return taskcard;
    }
  }, [taskData, taskcard, viewMode]);

  useEffect(() => {
    setIsLoading(true);
    setView(
      auth?.user?.role === "Super Admin" || auth?.user?.role === "Administrator"
        ? "table"
        : "card",
    );
    setViewMode(
      auth?.user?.role === "Super Admin" || auth?.user?.role === "Administrator"
        ? "admin"
        : "user",
    );
    const initialSearch = searchParams.get("search") || "";
    getDataTask(1, initialSearch);
    getTaskActive(1, initialSearch);
    getPersonData();
    getCategory();
    setIsLoading(false);
  }, []);

  const [fields, setFields] = useState<any>([]);

  // คำนวณเวลา
  const calculateDaysLeft = (end_date: string) => {
    const end = dayjs(end_date, "YYYY-MM-DD HH:mm:ss");
    const now = dayjs();
    return Math.ceil(end.diff(now, "hour") / 24);
  };

  // convert date
  const formatThaiDate = (dateString: string) => {
    // const date = dayjs(dateString, "DD/MM/YYYY");
    const date = dayjs(dateString, "YYYY-MM-DD");
    return date.format("D MMM BBBB");
  };

  // ฟังก์ชันดึงวันที่จาก event_date
  const getEventDates = (event: any) => {
    let startDate = null;
    let endDate = null;

    try {
      if (event.event_date) {
        let eventData = event.event_date;

        // Parse JSON ซ้อนกัน
        while (typeof eventData === "string") {
          try {
            eventData = JSON.parse(eventData);
          } catch (e) {
            break;
          }
        }

        // ถ้าเป็น array ให้เอา element แรก
        if (Array.isArray(eventData) && eventData.length > 0) {
          eventData = eventData[0];
        }

        // ดึงค่า start_date และ end_date
        if (eventData && typeof eventData === "object") {
          startDate = eventData.start_date;
          endDate = eventData.end_date;
        }
      }

      // Fallback ไปใช้ฟิลด์ start_date และ end_date แบบเดิม
      if (!startDate && event.start_date) {
        startDate = event.start_date;
      }
      if (!endDate && event.end_date) {
        endDate = event.end_date;
      }
    } catch (error) {
      console.error("Error parsing event_date:", error, event);
    }

    return { startDate, endDate };
  };

  return (
    <Layout>
      <Content className="tasks-layout">
        <div>
          <Row justify="space-between" align="middle">
            <Col xs={24} md={3} lg={6} xl={3}>
              <Breadcrumb
                separator=">"
                items={[
                  {
                    title: (
                      <span style={{ fontWeight: "bold" }}>{t("Task")}</span>
                    ),
                  },
                ]}
              />
            </Col>
            <Col xs={24} md={21} lg={18} xl={21}>
              <Row justify="end" gutter={[10, 10]}>
                <Col xs={24} sm={24} md={8} lg={6}>
                  <Search
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      if (viewMode == "admin") {
                        getDataTask(1, e.target.value);
                      } else {
                        getTaskActive(1, e.target.value);
                      }
                    }}
                    onSearch={onSearch}
                    style={{ marginRight: "10px" }}
                  />
                </Col>
                {auth.user.role === "Super Admin" ? (
                  <>
                    <Button
                      style={{ backgroundColor: "#00215E", color: "white" }}
                      type="primary"
                      key="primary"
                      onClick={async () => {
                        navigate("/task/create");
                      }}
                    >
                      <PlusOutlined />
                      {t("Add Task")}
                    </Button>
                  </>
                ) : null}
              </Row>
            </Col>
          </Row>
          <hr />
        </div>

        <Row
          gutter={8}
          align={"middle"}
          justify={"end"}
          style={{ marginBottom: "0.4rem" }}
        >
          <>
            <Col>{t("Tag")} : </Col>
            <Col>
              <Select
                style={{ width: "120px", textAlign: "center" }}
                value={valueCategory}
                onChange={(value) => {
                  setValueCategory(value);
                  if (viewMode == "admin") {
                    // if (auth?.user?.role != "User") {
                    getDataTask(1, null, value);
                  } else {
                    getTaskActive(1, null, value);
                  }
                }}
                options={optionsCategory}
              ></Select>
            </Col>
          </>
          {/* choose display  */}
          {auth.user.role == "Super Admin" ||
          auth.user.role == "Administrator" ? (
            <>
              <Col>{t("View mode")} : </Col>
              <Col>
                <Select
                  style={{ width: "120px", textAlign: "center" }}
                  value={viewMode}
                  onChange={(value) => {
                    setViewMode(value);
                    setView(value == "admin" ? "table" : "card");
                  }}
                  options={[
                    { label: "Admin", value: "admin" },
                    { label: "User", value: "user" },
                  ]}
                ></Select>
              </Col>

              {viewMode == "admin" && (
                <>
                  <Col>
                    <Button
                      style={{
                        borderColor: "#91caff",
                        backgroundColor:
                          view === "table" ? "#e6f4ff" : "#ffffff",
                      }}
                      icon={<BarsOutlined style={{ color: "#0958d9" }} />}
                      onClick={() => handleChangeViewMode("table")}
                    />
                  </Col>
                  <Col>
                    <Button
                      style={{
                        borderColor: "#91caff",
                        backgroundColor:
                          view === "card" ? "#e6f4ff" : "#ffffff",
                      }}
                      icon={<AppstoreOutlined style={{ color: "#0958d9" }} />}
                      onClick={() => handleChangeViewMode("card")}
                    />
                  </Col>
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </Row>

        {/* view card or table */}
        {isLoading ? (
          <Row justify="center" align="middle" style={{ height: "50vh" }}>
            <Spin size="large" />
          </Row>
        ) : view === "table" ? (
          <Table
            className="custom-table-task"
            rowKey="task_id"
            onRow={() => ({
              style: { cursor: "default" },
            })}
            columns={columns}
            dataSource={data}
            // dataSource={filteredData}
            pagination={{
              className: "custom-pagination",
              showTotal: (total, range) =>
                `แสดงรายการต่อหน้า : ${range[0]}-${range[1]} จาก ${total} รายการ`,
              defaultPageSize: 10,
              showSizeChanger: false,
              pageSizeOptions: ["10", "25", "50", "100"],
              total: total,
              onChange: (page) => {
                getDataTask(page);
                setPage(page);
              },
            }}
            scroll={{ x: "max-content" }}
          />
        ) : (
          <div>
            <Content>
              {data.length > 0 ? (
                <Row gutter={[16, 16]}>
                  {data.map((event: any) => {
                    let arr = event.tags
                      .toString()
                      .replace("[", "")
                      .replace("]", "")
                      .replace(/"/g, "");
                    // ดึงวันที่จาก event_date
                    const { startDate, endDate } = getEventDates(event);

                    const daysLeft = endDate ? calculateDaysLeft(endDate) : 0;
                    let end_dateStyle = {};
                    let end_dateDisplay = endDate
                      ? formatThaiDate(endDate)
                      : "-";
                    let end_dateClass = "";

                    if (endDate) {
                      if (daysLeft <= 0) {
                        end_dateStyle = {
                          color: "red",
                          fontSize: "16px",
                          fontFamily: "IBM Plex Sans Thai",
                        };
                        end_dateDisplay = t("Registration ended");
                      } else if (daysLeft < 5) {
                        end_dateStyle = { fontSize: "18px" };
                        end_dateDisplay = `${daysLeft} ${t("Day")}`;
                        end_dateClass = "blink";
                      }
                    }
                    // {filteredData.slice(0, displayCount).map((event) => {
                    const tags = JSON.parse(event.tags || "[]");

                    return (
                      <Col
                        xs={24}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={6}
                        xxl={6}
                        key={event.task_id}
                      >
                        <Card
                          cover={
                            <div
                              style={{
                                position: "relative",
                                paddingTop: "56.25%", // 16:9 Aspect Ratio
                                overflow: "hidden",
                              }}
                            >
                              <img
                                alt={event.name}
                                src={
                                  event.img?.startsWith("/data/")
                                    ? `${process.env.REACT_APP_API}${event.img}`
                                    : event.img
                                }
                                style={{
                                  position: "absolute",
                                  padding: "5px",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "30px",
                                }}
                              />
                            </div>
                          }
                          hoverable
                          style={{
                            borderRadius: "25px",
                            overflow: "hidden",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          bodyStyle={{
                            padding: "0",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                          className="custom-card"
                        >
                          <div
                            style={{
                              padding: "10px 10px 10px 10px",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            {/* title */}
                            <Row>
                              <b
                                className="event-name"
                                style={{
                                  fontSize: 18,
                                  width: "100%",
                                  marginBottom: 10,
                                }}
                              >
                                {event.name}
                              </b>
                            </Row>

                            {/* tag */}
                            <Row align="top" style={{ marginBottom: 8 }}>
                              <Col span={24}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    minHeight: "32px",
                                  }}
                                >
                                  <p
                                    className="startend"
                                    style={{
                                      marginBottom: 0,
                                      marginRight: 10,
                                      flexShrink: 0,
                                    }}
                                  >
                                    {t("Tag")} :
                                  </p>
                                  {tags.length > 0 ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "4px",
                                        flex: 1,
                                      }}
                                    >
                                      {expandedTags[event.task_id] ? (
                                        // แสดง tag ทั้งหมดเมื่อขยาย
                                        <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "4px",
                                          }}
                                        >
                                          {tags.map(
                                            (tag: any, index: number) => (
                                              <Tag
                                                key={`${event.task_id}-tag-${index}`}
                                                className="tag-item"
                                                style={{
                                                  margin: 0,
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {tag}
                                              </Tag>
                                            ),
                                          )}
                                          <Tag
                                            className="tag-item"
                                            style={{
                                              margin: 0,
                                              cursor: "pointer",
                                              whiteSpace: "nowrap",
                                              backgroundColor: "#f0f0f0",
                                              borderStyle: "dashed",
                                            }}
                                            onClick={() => {
                                              setExpandedTags((prev) => ({
                                                ...prev,
                                                [event.task_id]: false,
                                              }));
                                            }}
                                          >
                                            {t("Show less") || "แสดงน้อยลง"}
                                          </Tag>
                                        </div>
                                      ) : (
                                        // แสดง tag เดียวและปุ่ม +
                                        <div
                                          style={{
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            gap: "4px",
                                          }}
                                        >
                                          <Tag
                                            className="tag-item"
                                            style={{
                                              margin: 0,
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            {tags[0]}
                                          </Tag>
                                          {tags.length > 1 && (
                                            <Tag
                                              className="tag-item"
                                              style={{
                                                margin: 0,
                                                cursor: "pointer",
                                                whiteSpace: "nowrap",
                                              }}
                                              onClick={() => {
                                                setExpandedTags((prev) => ({
                                                  ...prev,
                                                  [event.task_id]: true,
                                                }));
                                              }}
                                            >
                                              +{tags.length - 1}
                                            </Tag>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="start-date"> - </span>
                                  )}
                                </div>
                              </Col>
                            </Row>

                            {/* date */}
                            <div style={{ flex: 1 }}>
                              <Row className="event-details">
                                <Col xs={24}>
                                  <Row justify={"space-between"}>
                                    <Col xs={11} sm={9} md={7} lg={5} xl={9}>
                                      <p className="startend">
                                        {t("Start date")} :{" "}
                                      </p>
                                    </Col>
                                    <Col
                                      xs={12}
                                      sm={14}
                                      md={16}
                                      lg={18}
                                      xl={14}
                                    >
                                      <span className="start-date">
                                        {/* {event.type === 2
                                          ? " - "
                                          : startDate
                                            ? formatThaiDate(startDate)
                                            : " - "} */}
                                        {startDate ? formatThaiDate(startDate) : " - "}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col xs={24} style={{ marginBottom: 10 }}>
                                  <Row justify={"space-between"}>
                                    <Col xs={11} sm={9} md={7} lg={5} xl={9}>
                                      <p className="startend">
                                        {t("End date")} :{" "}
                                      </p>
                                    </Col>
                                    <Col
                                      xs={12}
                                      sm={14}
                                      md={16}
                                      lg={18}
                                      xl={14}
                                    >
                                      <span
                                        className={`end-date ${end_dateClass}`}
                                        style={end_dateStyle}
                                      >
                                        {/* {event.type === 2
                                          ? " - "
                                          : endDate
                                            ? end_dateDisplay
                                            : " - "} */}
                                        {endDate ? end_dateDisplay : " - "}
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>

                            {/* footer */}
                            <Row
                              justify={"space-between"}
                              align={"middle"}
                              style={{ marginTop: "auto" }}
                            >
                              <Divider
                                style={{
                                  marginTop: "1px",
                                  marginBottom: "15px",
                                  borderColor: "#7A7A7A",
                                }}
                              />
                              <Col>
                                <Button
                                  className="btnread"
                                  type="link"
                                  onClick={() => {
                                    window.scrollTo(0, 0);
                                    navigate(`/task/detail/${event.task_id}`, {
                                      state: { EventName: event.task_id },
                                    });
                                  }}
                                >
                                  {/* {" "} */}
                                  {t("Read More")}
                                  <DoubleRightOutlined className="iconright" />
                                </Button>
                              </Col>
                              <Col>
                                {auth.user?.user_id && (
                                  <Button
                                    className="btnlead"
                                    style={{ margin: "5px" }}
                                    type="primary"
                                    shape="circle"
                                    onClick={() => {
                                      window.scrollTo(0, 0);
                                      navigate(`/team/${event.task_id}`);
                                    }}
                                  >
                                    <TeamOutlined
                                      style={{ color: "#ffffff" }}
                                    />
                                  </Button>
                                )}
                                <Button
                                  className="btnlead"
                                  type="primary"
                                  shape="circle"
                                  onClick={() => {
                                    window.scrollTo(0, 0);
                                    navigate(
                                      `/score/leaderboard/${event.task_id}`,
                                    );
                                  }}
                                >
                                  <TrophyOutlined
                                    style={{ color: "#ffffff" }}
                                  />
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              ) : (
                <Content
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "50vh",
                  }}
                >
                  <Row
                    justify="center"
                    align="middle"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Col>
                      <Empty description="No data" />
                    </Col>
                  </Row>
                </Content>
              )}
              {data.length > 0 && cardTotal > 0 && (
                <div
                  className="card-pagination-wrapper"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      color: "#666",
                      fontSize: "14px",
                    }}
                  >
                    {t("Showing")}{" "}
                    <strong>
                      {(cardPage - 1) * 8 + 1}-
                      {Math.min(cardPage * 8, cardTotal)}
                    </strong>{" "}
                    {t("of")} <strong>{cardTotal}</strong> {t("items")}
                  </div>
                  <Pagination
                    current={cardPage}
                    total={cardTotal}
                    pageSize={8}
                    showSizeChanger={false}
                    showLessItems
                    onChange={(newPage) => {
                      setCardPage(newPage);
                      getTaskActive(newPage);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                    itemRender={(page, type, originalElement) => {
                      if (type === "prev") {
                        return (
                          <Button
                            style={{
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            ← {t("Previous")}
                          </Button>
                        );
                      }
                      if (type === "next") {
                        return (
                          <Button
                            style={{
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {t("Next")} →
                          </Button>
                        );
                      }
                      return originalElement;
                    }}
                  />
                </div>
              )}
            </Content>
          </div>
        )}
      </Content>

      <Modal
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontSize: "20px",
              fontWeight: 600,
            }}
          >
            {t("Using the Docker Registry")}
          </div>
        }
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        width="90%"
        style={{ maxWidth: "900px", top: 20 }}
        bodyStyle={{
          maxHeight: "70vh",
          overflowY: "auto",
          padding: "24px",
          fontSize: 14,
        }}
        footer={
          <div style={{ textAlign: "right", padding: "8px 0" }}>
            <Button
              type="primary"
              onClick={() => setIsModalOpen(false)}
              style={{
                borderRadius: "8px",
                height: "40px",
                paddingInline: "24px",
              }}
            >
              {t("Close")}
            </Button>
          </div>
        }
      >
        <Row gutter={[16, 24]}>
          {/* Step 1: Login */}
          <Col xs={24}>
            <Card
              style={{
                borderRadius: "12px",
                border: "1px solid #e8f4f8",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
              bodyStyle={{ padding: "20px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #52c41a 0%, #73d13d 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <LoginOutlined style={{ color: "#fff", fontSize: "24px" }} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <Tag
                      color="green"
                      style={{ margin: 0, borderRadius: "4px" }}
                    >
                      Step 1
                    </Tag>
                    <Title level={5} style={{ margin: 0 }}>
                      {t("Login")}
                    </Title>
                  </div>
                  <p
                    style={{
                      color: "#666",
                      marginBottom: "12px",
                      fontSize: "14px",
                    }}
                  >
                    {t("Dictation")}
                  </p>
                  <div
                    style={{
                      background: "#1e1e1e",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <code
                      style={{
                        color: "#4ec9b0",
                        fontSize: "13px",
                        fontFamily: "'Fira Code', 'Consolas', monospace",
                        wordBreak: "break-all",
                        flex: 1,
                      }}
                    >
                      {tutorial.login}
                    </code>
                    <Tooltip title="Copy">
                      <Button
                        type="text"
                        icon={<CopyOutlined style={{ color: "#fff" }} />}
                        onClick={() => {
                          navigator.clipboard.writeText(tutorial.login);
                          message.success("Copied to clipboard!");
                        }}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </div>
                  <div
                    style={{
                      marginTop: "12px",
                      padding: "10px 14px",
                      background: "#f6ffed",
                      borderRadius: "6px",
                      border: "1px solid #b7eb8f",
                      marginBottom: "12px"
                    }}
                  >
                    <CheckCircleFilled
                      style={{ color: "#52c41a", marginRight: "8px" }}
                    />
                    <span style={{ fontSize: "13px", color: "#333" }}>
                      {t("Then enter the usercode")} (
                      <strong>{userData.user_code}</strong>){" "}
                      {t("and user password")}
                    </span>
                  </div>
                  <div
                    style={{
                      background: "#1e1e1e",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <code
                      style={{
                        color: "#4ec9b0",
                        fontSize: "13px",
                        fontFamily: "'Fira Code', 'Consolas', monospace",
                        wordBreak: "break-all",
                        flex: 1,
                      }}
                    >
                      {userData.user_code}
                    </code>
                    <Tooltip title="Copy">
                      <Button
                        type="text"
                        icon={<CopyOutlined style={{ color: "#fff" }} />}
                        onClick={() => {
                          navigator.clipboard.writeText(userData.user_code);
                          message.success("Copied to clipboard!");
                        }}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Card>
          </Col>

          {/* Step 2: Push Image */}
          <Col xs={24}>
            <Card
              style={{
                borderRadius: "12px",
                border: "1px solid #e8f4f8",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
              bodyStyle={{ padding: "20px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #1890ff 0%, #69c0ff 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <CloudUploadOutlined
                    style={{ color: "#fff", fontSize: "24px" }}
                  />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <Tag
                      color="blue"
                      style={{ margin: 0, borderRadius: "4px" }}
                    >
                      Step 2
                    </Tag>
                    <Title level={5} style={{ margin: 0 }}>
                      {t("Push Image")}
                    </Title>
                  </div>

                  {/* Step 2.1: Tag Image */}
                  <p
                    style={{
                      color: "#666",
                      marginBottom: "12px",
                      fontSize: "14px",
                    }}
                  >
                    <strong>2.1</strong>{" "}
                    {t(
                      "Create the desired image by building or tagging it with the registry name in front",
                    )}
                  </p>
                  <div
                    style={{
                      background: "#1e1e1e",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                      marginBottom: "16px",
                    }}
                  >
                    {editingField.image_tag ? (
                      <input
                        value={editableTutorial.image_tag}
                        onChange={(e) =>
                          setEditableTutorial((prev) => ({
                            ...prev,
                            image_tag: e.target.value,
                          }))
                        }
                        style={{
                          color: "#dcdcaa",
                          fontSize: "13px",
                          fontFamily: "'Fira Code', 'Consolas', monospace",
                          flex: 1,
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.25)",
                          borderRadius: "4px",
                          outline: "none",
                          padding: "4px 8px",
                          width: "100%",
                        }}
                        autoFocus
                      />
                    ) : (
                      <code
                        style={{
                          color: "#dcdcaa",
                          fontSize: "13px",
                          fontFamily: "'Fira Code', 'Consolas', monospace",
                          wordBreak: "break-all",
                          flex: 1,
                        }}
                      >
                        {editableTutorial.image_tag}
                      </code>
                    )}
                    <Tooltip title={editingField.image_tag ? "Done" : "Edit"}>
                      <Button
                        type="text"
                        icon={
                          editingField.image_tag ? (
                            <CheckCircleFilled style={{ color: "#52c41a" }} />
                          ) : (
                            <EditOutlined style={{ color: "#fff" }} />
                          )
                        }
                        onClick={() =>
                          setEditingField((prev) => ({
                            ...prev,
                            image_tag: !prev.image_tag,
                          }))
                        }
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Copy">
                      <Button
                        type="text"
                        icon={<CopyOutlined style={{ color: "#fff" }} />}
                        onClick={() => {
                          navigator.clipboard.writeText(editableTutorial.image_tag);
                          message.success("Copied to clipboard!");
                        }}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </div>

                  {/* Step 2.2: Push Image */}
                  <p
                    style={{
                      color: "#666",
                      marginBottom: "12px",
                      fontSize: "14px",
                    }}
                  >
                    <strong>2.2</strong> {t("Push image into docker registry")}
                  </p>
                  <div
                    style={{
                      background: "#1e1e1e",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    {editingField.image_push ? (
                      <input
                        value={editableTutorial.image_push}
                        onChange={(e) =>
                          setEditableTutorial((prev) => ({
                            ...prev,
                            image_push: e.target.value,
                          }))
                        }
                        style={{
                          color: "#ce9178",
                          fontSize: "13px",
                          fontFamily: "'Fira Code', 'Consolas', monospace",
                          flex: 1,
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.25)",
                          borderRadius: "4px",
                          outline: "none",
                          padding: "4px 8px",
                          width: "100%",
                        }}
                        autoFocus
                      />
                    ) : (
                      <code
                        style={{
                          color: "#ce9178",
                          fontSize: "13px",
                          fontFamily: "'Fira Code', 'Consolas', monospace",
                          wordBreak: "break-all",
                          flex: 1,
                        }}
                      >
                        {editableTutorial.image_push}
                      </code>
                    )}
                    <Tooltip title={editingField.image_push ? "Done" : "Edit"}>
                      <Button
                        type="text"
                        icon={
                          editingField.image_push ? (
                            <CheckCircleFilled style={{ color: "#52c41a" }} />
                          ) : (
                            <EditOutlined style={{ color: "#fff" }} />
                          )
                        }
                        onClick={() =>
                          setEditingField((prev) => ({
                            ...prev,
                            image_push: !prev.image_push,
                          }))
                        }
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="Copy">
                      <Button
                        type="text"
                        icon={<CopyOutlined style={{ color: "#fff" }} />}
                        onClick={() => {
                          navigator.clipboard.writeText(editableTutorial.image_push);
                          message.success("Copied to clipboard!");
                        }}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Card>
          </Col>

          {/* Step 3: Logout */}
          <Col xs={24}>
            <Card
              style={{
                borderRadius: "12px",
                border: "1px solid #e8f4f8",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
              bodyStyle={{ padding: "20px" }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #ff7875 0%, #ff9c6e 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <LogoutOutlined style={{ color: "#fff", fontSize: "24px" }} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <Tag
                      color="orange"
                      style={{ margin: 0, borderRadius: "4px" }}
                    >
                      Step 3
                    </Tag>
                    <Title level={5} style={{ margin: 0 }}>
                      {t("Logout")}
                    </Title>
                  </div>
                  <p
                    style={{
                      color: "#666",
                      marginBottom: "12px",
                      fontSize: "14px",
                    }}
                  >
                    {t("Dictation")}
                  </p>
                  <div
                    style={{
                      background: "#1e1e1e",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <code
                      style={{
                        color: "#c586c0",
                        fontSize: "13px",
                        fontFamily: "'Fira Code', 'Consolas', monospace",
                        wordBreak: "break-all",
                        flex: 1,
                      }}
                    >
                      {tutorial.logout}
                    </code>
                    <Tooltip title="Copy">
                      <Button
                        type="text"
                        icon={<CopyOutlined style={{ color: "#fff" }} />}
                        onClick={() => {
                          navigator.clipboard.writeText(tutorial.logout);
                          message.success("Copied to clipboard!");
                        }}
                        style={{
                          background: "rgba(255,255,255,0.1)",
                          borderRadius: "6px",
                          flexShrink: 0,
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Modal>
    </Layout>
  );
};

export default Taskmainpage;
